export const FETCH_INVOICES_SUCCESS = 'FETCH_INVOICES_SUCCESS';
export const FETCHING_INVOICES_LINES_SUCCESS = 'FETCHING_INVOICES_LINES_SUCCESS';
export const FETCHING_INVOICES = 'FETCHING_INVOICES';
export const FETCHING_INVOICES_LINES = 'FETCHING_INVOICES_LINES';
export const RESET_INVOICES = 'RESET_INVOICES';
export const RESET_INVOICES_LINES = 'RESET_INVOICES_LINES';
export const DELETE_INVOICES_SUCCESS = ' DELETE_INVOICES_SUCCESS';
export const DELETE_INVOICES_LINES_SUCCESS = ' DELETE_INVOICES_LINES_SUCCESS';
export const FETCHING_INVOICES_LINES_UNFILTERED = 'FETCHING_INVOICES_LINES_UNFILTERED';
export const FETCH_INVOICE_SUCCESS = 'FETCH_INVOICE_SUCCESS';
export const FETCHING_INVOICE = 'FETCHING_INVOICE';


// WEBPACK FOOTER //
// ./src/redux/invoices/InvoicesConstants.js